<template>
  <v-theme-provider :dark="dark">
    <div align="center">
      <!--        :src="require('@/assets/zero-logo-dark.svg')" -->
      <base-img
        :src="require('@/assets/compac/logo.png')"
        contain
        max-width="128"
        min-height="78"
        width="100%"
      />

      <base-title
        size="text-body-1"
        space="4"
        title="CONSEJO MEXICANO DE PATOLOGÍA CLÍNICA Y MEDICINA DE LABORATORIO, A. C."
        weight="regular"
        align="center"
      />

      <base-body>
        <a :href="path_aviso_privacidad" target="_blank">Consulta nuestro Aviso de Privacidad</a>
      </base-body>

     <!-- <base-btn
        class="mb-12"
        color="white"
        outlined
      >
        Requires ayuda
      </base-btn>-->
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseInfo',

    props: {
      title: String,
      dark: Boolean,
    },

    data: () => ({
      path_aviso_privacidad:process.env.VUE_APP_BASE_URL +'/avisoprivacidad/aviso_privacidad_compac.pdf',
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Dirección',
          text: '8553 N. Beach St. Ste. 227<br>Fort Worth, Texas 76137',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '01 (800) 433 744<br>01 (800) 433 633',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'john@vuetifyjs.com<br>heather@vuetifyjs.com',
        },
      ],
    }),
  }
</script>
